import { ZoomIn, ZoomOut, RotateCcw } from 'lucide-react';
import { MAX_WIDTH_ZOOM, MIN_WIDTH_ZOOM } from './useChartWidthZoom';

interface ChartZoomControlsProps {
  targetZoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
}

export const ChartZoomControls = ({
  targetZoom,
  onZoomIn,
  onZoomOut,
  onReset,
}: ChartZoomControlsProps) => (
  <div className="flex shrink-0 items-center gap-1">
    <button
      type="button"
      className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-[#E2E5EA] text-blueprint-blue hover:bg-[rgba(0,39,63,0.04)] disabled:opacity-40"
      aria-label="Zoom out (narrower)"
      disabled={targetZoom <= MIN_WIDTH_ZOOM}
      onClick={onZoomOut}
    >
      <ZoomOut className="h-4 w-4" />
    </button>
    <button
      type="button"
      className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-[#E2E5EA] text-blueprint-blue hover:bg-[rgba(0,39,63,0.04)] disabled:opacity-40"
      aria-label="Zoom in (wider)"
      disabled={targetZoom >= MAX_WIDTH_ZOOM}
      onClick={onZoomIn}
    >
      <ZoomIn className="h-4 w-4" />
    </button>
    <button
      type="button"
      className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-[#E2E5EA] text-blueprint-blue hover:bg-[rgba(0,39,63,0.04)] disabled:opacity-40"
      aria-label="Reset width zoom"
      disabled={targetZoom === MIN_WIDTH_ZOOM}
      onClick={onReset}
    >
      <RotateCcw className="h-4 w-4" />
    </button>
    <span className="ml-1 text-xs tabular-nums text-heritage-grey">
      {`${targetZoom.toFixed(1)}×`}
    </span>
  </div>
);
